module.exports = __webpack_public_path__ + "static/img/retain.2f429a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/retain.png
// module id = PzOV
// module chunks = 1